module.exports = __webpack_public_path__ + "img/auto_approve_candidate.9f5ab9fd.svg";